export default __webpack_public_path__ + "static/media/Ethos5.f0d78b73.jpg";